import { UnixTimestamp } from '@sparkdotfi/common-universal'

import { MobileViewOptions } from '../types'
import { cn } from '@/ui/utils/style'

interface DateCellProps {
  value: UnixTimestamp
  mobileViewOptions?: MobileViewOptions
  className?: string
  'data-testid'?: string
}

export function DateCell({ value, mobileViewOptions, className, 'data-testid': dataTestId }: DateCellProps) {
  if (mobileViewOptions?.isMobileView) {
    return (
      <div className="flex flex-row items-center justify-between">
        <div className="typography-label-4 w-full text-secondary">{mobileViewOptions.rowTitle}</div>
        <div className={cn('typography-label-3', className)} data-testid={dataTestId}>
          {dateFormatter.format(value.toDate())}
        </div>
      </div>
    )
  }

  return (
    <div className={cn('typography-label-3 flex w-full justify-end', className)} data-testid={dataTestId}>
      {dateFormatter.format(value.toDate())}
    </div>
  )
}

const dateFormatter = new Intl.DateTimeFormat(navigator.language, {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})
